import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService, LanguageService } from '../../shared/services';
import { InspectionPlugin } from '../../shared/models/index';

@Injectable()
export class MachineSafetyPluginService extends InspectionPluginService {
  private yesNoKeys = [
    { value: 1, label: 'plugins.machinesafety.yes' },
    { value: 2, label: 'plugins.machinesafety.no' }
  ];

  private yesNoOptions = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, inspectionFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe((value) => this.applyTranslations());
  }

  getYesNoOptions() {
    return this.yesNoOptions;
  }

  public updateMachineSafety(inspectionId: string, pointId: string, pluginId: string, machineSafety: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, machineSafety).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private applyTranslations() {
    this.yesNoOptions = [];
    this.copyTranslationValues(this.yesNoKeys, this.yesNoOptions, this.language);
  }

  private update(inspectionId: string, pointId: string, pluginId: string, machineSafety: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, machineSafety, 'MachineSafety').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
